interface DeissadvantagedCardProps {
  variant?: "pozitii" | "post";
}

export default function DeissadvantagedCard({
  variant = "post",
}: DeissadvantagedCardProps) {
  const title =
    variant === "pozitii"
      ? "Pozițiile noastre sunt destinate persoanelor din grupuri dezavantajate pe piața muncii"
      : "Acest post este destinat persoanelor din grupuri dezavantajate pe piața muncii";

  const categories = [
    "Studenți",
    "Persoane aflate în căutarea unui loc de muncă",
    "Șomeri și șomeri de lungă durată",
    "Persoane din grupuri dezavantajate pe piața muncii",
    "Persoane inactive",
  ];

  return (
    <div className="bg-gradient-to-br from-[#E76F51]/15 to-[#E9C46A]/15 rounded-3xl border-2 border-[#E76F51]/40 px-6 py-6">
      <h3 className="text-lg font-bold text-[#264653] mb-3 text-center">
        {title}
      </h3>
      <p className="text-sm text-[#264653]/85 leading-relaxed mb-4 text-center">
        Mindtale își asumă un angajament social clar: oferim oportunități reale
        de angajare{" "}
        <span className="font-semibold">
          plătite cu salariu corect și contract legal
        </span>{" "}
        pentru:
      </p>
      <div className="flex flex-wrap justify-center gap-2 max-w-3xl mx-auto">
        {categories.map((category) => (
          <div
            key={category}
            className="bg-white/80 backdrop-blur-sm rounded-full px-4 py-2 border border-[#E76F51]/30 shadow-sm hover:shadow-md hover:border-[#E76F51]/50 transition-all duration-200"
          >
            <span className="text-sm text-[#264653]/90 font-medium">
              {category}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
